import { render } from "./DJvirtualCommerce.vue?vue&type=template&id=878c5e12&scoped=true"
import script from "./DJvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./DJvirtualCommerce.vue?vue&type=script&lang=js"

import "./DJvirtualCommerce.vue?vue&type=style&index=0&id=878c5e12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-878c5e12"

export default script